module.exports = __webpack_public_path__ + "static/media/0x.b68a1e46.svg";